/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface SearchNewProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const SearchNew: React.SFC<SearchNewProps> = ({size, ...props}) => (
  <svg viewBox="0 0 13 13" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M12.302,12.861c-0.15,0-0.291-0.059-0.396-0.165l-2.561-2.561 c-1.021,0.835-2.279,1.274-3.57,1.274c-3.107,0-5.636-2.528-5.636-5.635c0-3.108,2.528-5.636,5.637-5.636 c3.107,0,5.635,2.528,5.635,5.636c0,1.297-0.452,2.566-1.274,3.571l2.562,2.561c0.105,0.102,0.164,0.242,0.164,0.396 c0,0.149-0.059,0.29-0.165,0.396C12.593,12.803,12.453,12.861,12.302,12.861z M5.774,1.258c-2.49,0-4.517,2.026-4.517,4.517 c0,2.491,2.026,4.517,4.518,4.517c2.49,0,4.517-2.026,4.517-4.517C10.292,3.285,8.266,1.258,5.774,1.258z"
      fillRule="evenodd" clipRule="evenodd" />
  </svg>
);
SearchNew.displayName = 'SearchNew';
export default SearchNew;
/* tslint:enable */
/* eslint-enable */
